import React from 'react';
import useScreenSize from '../hooks/useScreenSize';

const SectionHeader = ({ icon: Icon, title, right = null }) => {
  const { isMobile } = useScreenSize();
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        {Icon && <Icon className="w-4 h-4 mr-2 text-blue-600" />}
        <h2 className={`${isMobile ? 'text-base' : 'text-lg'} font-semibold`}>{title}</h2>
      </div>
      {right}
    </div>
  );
};

export default SectionHeader;


